module.exports = __webpack_public_path__ + "static/media/card4_6.b8bdfbd8.png";